import { CheckCircle2, Download, Presentation, TriangleAlert } from "lucide-react";
import { PresentationAsset } from "@/api/models";
import ErrorDetails from "@/components/Message/ErrorDetails";
import { getErrorDetails, getErrorSummary } from "@/utils/errorMessages";

type Props = { asset: PresentationAsset; onDownload: (asset: PresentationAsset) => void };

export default function PresentationAssetCard({ asset, onDownload }: Props) {
  const starting = asset.status === "starting";
  const creating = asset.status === "creating";
  const failed = asset.status === "failed";
  const errorDetails = failed ? getErrorDetails(asset.error, asset.error_details) : undefined;
  const errorSummary = failed ? getErrorSummary(asset.error, errorDetails) : "";
  return <div className="max-w-[500px] w-full mt-3 mb-6 px-1" role={starting || creating ? "status" : undefined} aria-live={starting || creating ? "polite" : undefined}>
    <div className="rounded-2xl border border-base-300 bg-base-100 px-4 py-3.5 flex gap-3 items-center">
      <div className="w-10 h-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center shrink-0"><Presentation size={20} /></div>
      <div className="min-w-0 flex-1">
        <p className="font-semibold text-sm">{failed ? "Presentation couldn't be created" : starting ? "Starting presentation" : creating ? "Creating presentation" : asset.filename}</p>
        <p className="text-xs opacity-70">{failed ? errorSummary : starting ? "Preparing your PowerPoint…" : creating ? "Building your PowerPoint…" : "PowerPoint presentation · Ready"}</p>
        {failed && errorDetails && <ErrorDetails details={errorDetails} error={asset.error} />}
      </div>
      {starting || creating ? <span className="loading loading-spinner loading-sm text-primary" /> : failed ? <TriangleAlert className="text-error" size={20} /> : <button className="btn btn-primary btn-sm btn-outline" onClick={() => onDownload(asset)}><Download size={15} />Download</button>}
      {!creating && !failed && <CheckCircle2 className="text-success hidden" size={18} />}
    </div>
  </div>;
}
